import { css } from "@emotion/react";
import { BoxItem } from "@swo/storefront";
import React from "react";
import { ContentfulImage2 } from "../../../components/_shared-components/image-related/ContentfulImage2";
import { FONTS, fontSize } from "../../../styles/fonts";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { IntendedUseCard } from "../IntendedUseCard";
import { CSS_MQ } from "../../../styles/breakpoints";

export const IntendedUseBoxItemCard: React.FC<{
  card: BoxItem;
}> = ({ card }) => {
  const { link, headline, subheadline, image, ...rest } = card;

  switch (card.__typename) {
    case "ComponentBox": {
      return (
        <IntendedUseCard
          hasBorderRadius={false}
          link={link}
          attachStyles={css`
            position: relative;

            background-color: ${CSS_COLORS.GreenDark};

            text-decoration: none;
            color: ${CSS_COLORS.White};

            &:hover {
              ${CSS_MQ.atLeastSm} {
                img {
                  display: none;
                }
              }
            }
          `}
        >
          {image && (
            <ContentfulImage2
              assetId={image.image.sys.id}
              contentfulUrl={image.image.url}
              cropping={image}
              sizes="(max-width: 1439px) 250vw, 340px"
              css={css`
                height: 100%;
                width: 100%;

                display: block;

                ${CSS_MQ.atMostXs} {
                  aspect-ratio: 3/2;
                }

                ${CSS_MQ.atLeastSm} {
                  position: absolute;
                }

                object-fit: cover;
                object-position: center;
                z-index: 1;

                ${CSS_MQ.atLeastSm} {
                  border-radius: 8px;
                  filter: brightness(0.4) saturate(0.7) contrast(0.9);
                }
              `}
              withTransparency={true}
              alt={image.image.description ?? ""}
            />
          )}

          <div
            css={css`
              flex-grow: 1;
              padding: 20px;

              ${CSS_MQ.atLeastSm} {
                display: grid;
                grid-template-rows: 1fr auto 1fr;
                grid-auto-flow: row;
              }

              position: relative;
              z-index: 2;
            `}
          >
            <div
              className="u-flex u-ai-end u-uppercase u-mb-2"
              css={css`
                ${CSS_MQ.atLeastSm} {
                  text-align: center;
                  justify-content: center;
                }
              `}
            >
              <span>{subheadline}</span>
            </div>

            <span css={[FONTS.MinervaModern500, fontSize.x4]} className="u-uppercase u-ta-center">
              {headline}
            </span>
          </div>
        </IntendedUseCard>
      );
    }
    default: {
      const _: never = card.__typename;
      return _;
    }
  }
};
